import triggerEcommerceTracking from "../functions/triggerEcommerceTracking";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.reg_users.show").length) return;
  triggerEcommerceTracking("gtmUsersArticlesVolunteer");
  triggerEcommerceTracking("gtmUsersArticlesJob");
});

$(() => {
  if (!$("body.reg_users.show_articles").length) return;
  const trackingId =
    location.pathname.split("/").pop() === "volunteer"
      ? "gtmUsersArticlesVolunteer"
      : "gtmUsersArticlesJob";
  triggerEcommerceTracking(trackingId, "person", {
    globalIndex: true,
    itemsPerPage: 20,
  });
});
